import umbrellaFamily from '../images/parasol.jpg'
import HeroSection from '../components/HeroSection'
import Oferta from './Oferta'

export default function Home() {
  return (
    <>
      <HeroSection
        image={umbrellaFamily}
        text="Twoje bezpieczeństwo pod parasolem naszych ubezpieczeń"
      />
      <Oferta />
      {/* dalsza zawartość strony */}
    </>
  )
}